import { action } from 'satcheljs';
import { AttachmentState } from 'owa-attachment-full-data';
import { AttachmentWellViewState } from 'owa-attachment-well-data';
/**
 * Action dispatched when we download attachments on toggle
 */
export default action(
    'initializeAttachmentStateForSmimeAttachments',
    (attachmentWell: AttachmentWellViewState, attachments: AttachmentState[]) => ({
        attachmentWell,
        attachments,
    })
);
